import { Card, CardContent, CardHeader } from "@material-ui/core";
import React from "react";
import CRUDExpense from "../CRUD/CRUDExpense";
import { useTranslation } from "react-i18next";

export default function NewExpense() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader title={t("topbar.newExpense")} />
      <CardContent>
        <CRUDExpense sm={12} md={6} />
      </CardContent>
    </Card>
  );
}
